import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const pause = (duration) => {
  return new Promise((resolve) => setTimeout(resolve, duration));
};

const authApi = createApi({
  reducerPath: "auth",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BASE_ENDPOINT}api/`,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("access-token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
    },
    fetchFn: async (...args) => {
      await pause(1000);
      return fetch(...args);
    },
  }),
  endpoints(builder) {
    return {
      fetchMe: builder.query({
        providesTags: (result, error, arg) => ["me"],
        query: () => {
          return {
            url: "auth/me",
            method: "GET",
            validateStatus: (response, result) =>
              response.status === 401 || response.status === 200,
          };
        },
      }),
      login: builder.mutation({
        invalidatesTags: () => ["me"],
        query: (login) => {
          return {
            url: "auth/login",
            method: "POST",
            body: login,
          };
        },
      }),
      googleAuth: builder.mutation({
        invalidatesTags: () => ["me"],
        query: (login) => {
          return {
            url: "auth/google-login",
            method: "POST",
            body: login,
          };
        },
      }),
      logout: builder.mutation({
        invalidatesTags: () => ["me"],
        query: () => {
          return {
            url: "auth/me",
            method: "POST",
          };
        },
      }),
    };
  },
});

export const {
  useFetchMeQuery,
  useLogoutMutation,
  useLoginMutation,
  useGoogleAuthMutation,
} = authApi;
export { authApi };
